import { AimsCommonPopupEditorData } from '@aims/common-components';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-inventory-return-popup',
  templateUrl: './inventory-return-popup.component.html',
  styleUrls: ['./inventory-return-popup.component.css']
})
export class InventoryReturnPopupComponent implements OnInit {

 public formGroup: any;
  public itemToReturn;
  public updatedQuantity: number;
  public maxReturnableQuantity: number;

 constructor(contentData: AimsCommonPopupEditorData) {
    this.itemToReturn = contentData.contentData.itemToReturn;
    this.formGroup = contentData.formGroup;
    this.maxReturnableQuantity = contentData.contentData.maxReturnableQuantity;

    this.formGroup.addControl('returnedQuantity', new FormControl(0, [Validators.required, Validators.max(this.maxReturnableQuantity), Validators.min(1)]));
  }

  ngOnInit(): void {
  }

}
